import { Grid } from "@mui/material";
import React from "react";
import { Input, InputDate } from "../../../controls";
import { MaxLength } from "../../../hooks/Method";

const CreditDebitCardFields = ({ values, handleInpChg, handleInpDate }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Input
          label="Name on Card"
          name="nameOnCard"
          inputProps={{ maxLength: 26 }}
          value={values.nameOnCard}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="Card Number"
          name="cardNumber"
          value={values.cardNumber}
          type="number"
          onInput={(e) => (e.target.value = MaxLength(e.target.value, 19))}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <InputDate
          label="Expiry Date"
          name="expiryDate"
          views={["year", "month"]}
          format="MM/YYYY"
          openTo="year"
          minDate={new Date()}
          value={values.expiryDate}
          onChange={(date) =>
            handleInpDate("expiryDate", new Date(date).toLocaleDateString())
          }
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Input
          label="Security Code"
          name="securityCode"
          value={values.securityCode}
          type="number"
          onInput={(e) => (e.target.value = MaxLength(e.target.value, 3))}
          onChange={handleInpChg}
        />
      </Grid>
    </Grid>
  );
};

export default CreditDebitCardFields;
